/**
 * @file XCCOMM AlbumFolderTag related fragments.
 */

import gql from 'graphql-tag';

import { UniformAlbumFolderTagLevelTeam } from '../../../../graphql/fragments/album-folder-tags';

export const SelectedIdentityAlbumFolderTagDetailsForMatching = gql`
  fragment SelectedIdentityAlbumFolderTagDetailsForMatching on IIdentityAlbumFolderTag {
    ... on IRecord {
      id
    }
    ... on IIdentityAlbumFolderTag {
      album_folder_tag {
        ... on IRecord {
          id
        }
        ... on IAlbumFolderTag {
          name
        }
      }
    }
    ... on IdentityUniformAlbumFolderTag {
      jersey_number
      uniform_album_folder_tag_level {
        id
        name
      }
      uniform_album_folder_tag_level_team {
        ...UniformAlbumFolderTagLevelTeam
      }
    }
  }
  ${UniformAlbumFolderTagLevelTeam}
`;
